export default {
    user: null,
    token: null,
    loading: false,
    error: null,
    whatstext:null,
    currentForm: "form-doc-number", 
    contacts: null
}